import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const OwnershipPie = ({ data }) => {

  const colorMap = {
    "Federal": "#F4A261", // Orange
    "State": "#CC0000",   // Red
    "Private": "#457B9D", // Blue
    "Tribal": "#2A9D8F"   // Teal
  };

  const chartData = {
    labels: data.map(d => d.type),
    datasets: [
      {
        data: data.map(d => d.percent),
        backgroundColor: data.map(d => colorMap[d.type] || "#cccccc")
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Utah Land Ownership Distribution",
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.parsed} %`,
        },
      },
    },
  };

  return (
    <div className="bg-white p-8 shadow-xl rounded-xl mb-16">

      <h2 className="text-2xl font-bold mb-6">
        Utah Land Ownership Distribution
      </h2>

      <div className="w-full max-w-md mx-auto h-80">
        <Pie data={chartData} options={options} />
      </div>

    </div>
  );
};

export default OwnershipPie;